export default function Title() {
  return <div className="insights-page-title">Get Topic Insights</div>;
}
